import { useShortIdContext } from '@air/provider-short-id';

/**
 * The share link's custom logo, when the publisher set one. A custom logo replaces the
 * entire workspace identity block (logo + name) on public `clip`, `board`, and `collection`
 * share pages; when unset, consumers fall through to the workspace logo and name. Must be
 * called within a `ShortIdProvider`.
 */
export const usePublicCustomLogo = (): { customLogoUrl: string | undefined } => {
  const { presentationSettings } = useShortIdContext();

  return { customLogoUrl: presentationSettings?.customLogo?.url };
};
